import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
const RedAsterisk = () => _jsx("span", { style: { color: "red" }, children: "*" });
export default RedAsterisk;
